import React from "react";
import { TextField, IconButton, Grid, InputAdornment } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
const Input = ({
  half,
  handleChange,
  label,
  name,
  type,
  handleShowPassword,
  autoFocus,
  style,
  placeholder,
}) => (
  <Grid item xs={12} sm={half ? 6 : 12}>
    <TextField
      name={name}
      onChange={handleChange}
      variant='standard'
      autoFocus={autoFocus}
      required
      fullWidth
      label={label}
      style={style}
      type={type}
      placeholder={placeholder}
      autoComplete={name === "password" ? "off" : ""}
      InputProps={
        name === "password"
          ? {
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton onClick={handleShowPassword}>
                    {type === "password" ? (
                      <VisibilityIcon />
                    ) : (
                      <VisibilityOffIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
              startAdornment: (
                <InputAdornment position='start'>
                  <LockIcon />
                </InputAdornment>
              ),
              disableUnderline: true,
            }
          : {
              startAdornment: (
                <InputAdornment position='start'>
                  <EmailIcon />
                </InputAdornment>
              ),
              disableUnderline: true,
            }
      }
    />
  </Grid>
);

export default Input;
